import styled from "@emotion/styled";
import { Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Box } from "@mui/system";
import { Fragment, useEffect, useState } from "react";
import { getProductMapping } from "../../http/api/ChainStoreAPI";
import {
  getOrigin,
  getPacking,
  getProductClass,
  getRank,
} from "../../http/api/MasterAPI";
import DetailItem from "./DetailItem";
import useChainStoreShortcut from "./useChainStoreShortcut";
import ChainStoreInfoModal from "../product/ProductPage/ChainStore/ChainStoreInfoModal";

const TableProductHeader = styled(Grid)({
  margin: 0,
  marginTop: 10,
  padding: 0,
  display: "flex",
  justifyContent: "center",
});

export default function DetailTable(props) {
  const { details, detailsAPI, addDetail, header, modalState } = props;
  const { handleKeyDown, handleKeyPress, focusNavigation } =
    useChainStoreShortcut({
      COLUMN_COUNT: 9,
      moveToIdCB: moveToIdCB,
    });
  const [ranks, setRanks] = useState([]);
  const [productClasses, setProductClasses] = useState([]);
  const [packings, setPackings] = useState([]);
  const [productsAC, setProductsAC] = useState([]);
  const [productSelectable, setProductSelectable] = useState([]);
  const [origins, setOrigins] = useState([]);

  async function GetRank() {
    let response = await getRank({});
    let listInfo = response.masterVarInfo;
    listInfo = listInfo
      .map((o) => ({
        rankId: o.varCd,
        rankName: o.varValue1,
      }))
      .filter((r) => r.rankId != 0);
    setRanks(listInfo);
  }
  async function GetProductClass() {
    let response = await getProductClass({});
    let listInfo = response.masterVarInfo;
    listInfo = listInfo
      .map((o) => ({
        productClassId: o.varCd,
        productClassName: o.varValue1,
      }))
      .filter((r) => r.productClassId != 0);
    setProductClasses(listInfo);
  }
  async function GetPacking() {
    let response = await getPacking({});
    let listInfo = response.masterVarInfo;
    listInfo = listInfo
      .map((o) => ({
        packingId: o.varCd,
        packingName: o.varValue1,
      }))
      .filter((r) => r.packingId != 0);
    setPackings(listInfo);
  }
  async function GetOrigin() {
    let response = await getOrigin({});
    let listOrigin = response.masterVarInfo;
    listOrigin = listOrigin.map((o) => ({
      originId: o.varCd,
      originName: o.varValue1,
    }));
    setOrigins(listOrigin);
  }
  useEffect(() => {
    GetRank();
    GetProductClass();
    GetPacking();
    GetOrigin();
  }, []);

  useEffect(() => {
    GetProductAC();
  }, [header.Value.buyerNo]);

  async function GetProductAC() {
    try {
      let response = await getProductMapping(header.Value.buyerNo);
      let listProduct = response.listChainStoreProductInfo;
      setProductsAC(listProduct);
    } catch {
      setProductsAC([]);
    }
  }

  useEffect(() => {
    const filteredProductSelectable = productsAC.filter(
      (p) => p.chainStoreProductTypeCd == header.Value.classNo
    );
    setProductSelectable(filteredProductSelectable);
  }, [productsAC, header.Value.classNo]);

  useEffect(() => {
    if (productsAC.length === 0 || detailsAPI.Value.length === 0) {
      return;
    }
    const eP = productsAC.find((p) => p.productId === detailsAPI.Value[0]?.productId);
  
    if (eP) {
      const typeId = eP.chainStoreProductTypeCd;
      header.update("classNo", typeId);
    } else {
      header.update("classNo", "");
    }
  }, [productsAC,detailsAPI.Value]);
  

  function updateDetail(index, newDetail) {
    details.updateIndex(index, newDetail);
  }

  async function moveToIdCB(id) {
    const item = id.split("-");
    if (item[1] >= details.Value.length) {
      //行の限界で、新しい対象を追加する
      console.log("Add detail");
      addDetail();
    }
  }
  return (
    <Fragment>
      {/* 内容ヘッダー */}
      <TableProductHeader
        container
        sx={{ backgroundColor: grey[200], borderRadius: 2 }}
      >
        <Grid item xs={0.9}>
          <Typography variant="h5" textAlign={"center"}>
            商品CD
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="h5" textAlign={"center"}>
            商品名
          </Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography variant="h5" textAlign={"center"}>
            産地
          </Typography>
        </Grid>
        <Grid item xs={1.2}>
          <Typography variant="h5" textAlign={"center"}>
            等級
          </Typography>
        </Grid>
        <Grid item xs={1.2}>
          <Typography variant="h5" textAlign={"center"}>
            階級
          </Typography>
        </Grid>
        <Grid item xs={1.2}>
          <Typography variant="h5" textAlign={"center"}>
            荷姿
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="h5" textAlign={"center"}>
            入数
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="h5" textAlign={"center"}>
            単価
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="h5" textAlign={"center"}>
            数量
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="h5" textAlign={"center"}>
            金額
          </Typography>
        </Grid>
      </TableProductHeader>

      {/* 内容一覧 */}
      <Box onKeyPress={handleKeyPress} onKeyDown={handleKeyDown} width="100%">
        {details.Value.map((detail, index) => {
          return (
            <DetailItem
              key={index}
              detail={detail}
              detailsAPI={detailsAPI}
              index={index}
              updateDetail={updateDetail}
              ranks={ranks}
              productClasses={productClasses}
              packings={packings}
              productsAC={productsAC}
              productSelectable={productSelectable}
              origins={origins}
              focusNavigation={focusNavigation}
            />
          );
        })}
      </Box>

      <ChainStoreInfoModal modalState={modalState} onClose={GetProductAC} />
      {/* <Button onClick={(e)=>{alert("hi")}}>TestButton</Button> */}
    </Fragment>
  );
}
